import { POST } from './ApiService'

const urlFactory = {
    handleLogin: () => `/api/seb-recipient-dashboard/vesecure`,
}

const AuthenticationService = {
    handleLogin: async (
        signingMethod: string,
        langId: string,
        metadata: Record<string, string>,
        ssn: string | undefined
    ) => {
        const body = {
            signingMethod,
            langId,
            metadata,
            ssn,
        }
        const authRequired = false
        return POST(urlFactory.handleLogin(), body, authRequired)
    },
}

export default AuthenticationService
